import React from 'react';

export const PdfIcon: React.FC = () => (
  <div className="w-14">
    <svg viewBox="0 0 50 60" xmlns="http://www.w3.org/2000/svg">
      <path d="M40 0 H10 C5 0, 5 0, 5 5 V55 C5 60, 5 60, 10 60 H40 C45 60, 45 60, 45 55 V15 Z" fill="#E53935"/>
      <path d="M40 0 L45 15 H35 Z" fill="#F44336"/>
      <text x="25" y="42" fontSize="18" fill="white" textAnchor="middle" fontWeight="bold" fontFamily="sans-serif">pdf</text>
    </svg>
  </div>
);